class Span {
  public message: string;
  public changed: boolean;

  constructor(message = "", changed = false) {
    (this.message = message), (this.changed = changed);
  }
}

class MiscellanyState {
  sidebarIsOpen: boolean = false;
  headerDropdownIsOpen: boolean = false;
  featuresIsOpen: boolean = true;
  error: Span = new Span();
  success: Span = new Span();
}

const state = new MiscellanyState();
const mutations = {
  TOGGLE_SIDEBAR_STATE(state: MiscellanyState): void {
    state.sidebarIsOpen = !state.sidebarIsOpen;
  },
  SET_SIDEBAR_STATE(state: MiscellanyState, option: boolean): void {
    state.sidebarIsOpen = option;
  },
  SET_DROPDOWN_MENU_STATE(state: MiscellanyState, option: boolean): void {
    state.headerDropdownIsOpen = option;
  },
  TOGGLE_HEADER_OPTIONS_STATE(state: MiscellanyState) {
    state.headerDropdownIsOpen = !state.headerDropdownIsOpen;
  },
  TOGGLE_CONTENT_FEATURES_STATE(state: MiscellanyState) {
    state.featuresIsOpen = !state.featuresIsOpen;
  },
  SET_CONTENT_FEATURES_STATE(state: MiscellanyState, featuresState: boolean) {
    state.featuresIsOpen = featuresState;
  },
  SET_ERROR(state: MiscellanyState, e: Span) {
    state.error.message = e.message;
    state.error.changed = e.changed;
  },
  SET_SUCCESS(state: MiscellanyState, success: Span) {
    state.success.message = success.message;
    state.success.changed = success.changed;
  },
};
const actions = {
  toggleSidebarState({ commit }: any): void {
    commit("TOGGLE_SIDEBAR_STATE");
  },
  setSidebarState({ commit }: any): void {
    commit("SET_SIDEBAR_STATE");
  },
  setDropdownMenuState({ commit }: any): void {
    commit("SET_DROPDOWN_MENU_STATE");
  },
  toggleHeaderOptionsState({ commit }) {
    commit("TOGGLE_HEADER_OPTIONS_STATE");
  },
  toggleContentFeaturesState({ commit }: any): void {
    commit("TOGGLE_CONTENT_FEATURES_STATE");
  },
  setContentFeaturesState({ commit }: any, featuresState: boolean): void {
    commit("SET_CONTENT_FEATURES_STATE", featuresState);
  },
  setError({ commit }, error) {
    commit("SET_ERROR", error);
  },
  setSuccess({ commit }, success) {
    commit("SET_SUCCESS", success);
  },
};
const getters = {
  headerDropdownIsOpen: (state) => state.headerDropdownIsOpen,
  featuresIsOpen: (state) => state.featuresIsOpen,
  sidebarIsOpen: (state) => state.sidebarIsOpen,
  error: (state) => state.error,
  success: (state) => state.success,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
